import { render, staticRenderFns } from "./SomethingWentWrong.vue?vue&type=template&id=1f45f5bf"
import script from "./SomethingWentWrong.vue?vue&type=script&lang=js"
export * from "./SomethingWentWrong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports